import { LeavingListener } from '@exam-center/components';
import { useGetExamCourseSettingsByExamCourseCodeQuery } from '@exam-center/graphql';
import { ErrorState, Loading } from '@shared/components';
import { useState } from 'react';

import { useExamCourse } from '../../providers';
import { DuringAndPostExamSettingsSectionForm } from '../during-and-post-exam-settings-section-form';
import { PreExamSettingsSectionForm } from '../pre-exam-settings-section-form';

interface ExamCourseSettingsFormContainerProps {
  examCourseCode: string;
}

export default function ExamCourseSettingsFormContainer(
  props: Readonly<ExamCourseSettingsFormContainerProps>,
) {
  const { examCourseCode } = props;
  const {
    examCourse: { id: examCourseId },
  } = useExamCourse();

  const [isPreExamSettingsFormDirty, setIsPreExamSettingsFormDirty] = useState(false);
  const [isDuringAndPostExamSettingsFormDirty, setIsDuringAndPostExamSettingsFormDirty] =
    useState(false);

  const {
    data,
    loading: isGettingExamCourseSettings,
    error,
  } = useGetExamCourseSettingsByExamCourseCodeQuery({
    variables: {
      getExamCourseByExamCourseCodeInput: {
        examCourseCode,
      },
    },
  });

  const isLoading = isGettingExamCourseSettings;

  if (isLoading) {
    return <Loading />;
  } else if (!data || error) {
    return <ErrorState />;
  }

  return (
    <>
      <PreExamSettingsSectionForm
        examCourseId={examCourseId}
        examCourseCode={examCourseCode}
        slotProps={{
          multipleSession: {
            minSession: 2,
            maxSession: 4,
          },
        }}
        onFormDirtyChange={setIsPreExamSettingsFormDirty}
      />
      <DuringAndPostExamSettingsSectionForm
        examCourseId={examCourseId}
        examCourseCode={examCourseCode}
        onFormDirtyChange={setIsDuringAndPostExamSettingsFormDirty}
      />
      <LeavingListener
        shouldBlockNavigation={isPreExamSettingsFormDirty || isDuringAndPostExamSettingsFormDirty}
      />
    </>
  );
}
